import React, { Component } from 'react';
import fee from './../data/fee'
import $ from 'jquery';

export default class Notification extends Component {

  render() {
    var token = [];
    var data = this.props.data;

    token['cobinhood'] = (window.cobinhoodprice / window.daoprice).toFixed(2);
    token['cybermiles'] = (window.cybermilesprice / window.daoprice).toFixed(2);
    token['wandx'] = (window.wandxprice / window.daoprice).toFixed(2);
    token['xyo'] = (window.xyoprice / window.daoprice).toFixed(2);
    token['ncash'] = (window.ncashprice / window.daoprice).toFixed(2);
    token['bitrewards'] = (window.bitrewardsprice / window.daoprice).toFixed(2);
    token['stacs'] = (window.stacsprice / window.daoprice).toFixed(2);
    token['orbs'] = (window.orbsprice / window.daoprice).toFixed(2);

    var active;
    $( document ).ready(function() {
        $("#history-tbody").html("");

      for (let name in token) {
        if (active) {
            active = "";
        } else {
            active = "active";
        }
        $("#history-tbody").append(
            `<tr class=${active}>
                <th scope="row">${name}</th>
                <td class="word-break">${token[name]}</td>
            </tr>`
        );
      }
      for (let name in fee) {
        if (active) {
            active = "";
        } else {
            active = "active";
        }
        $("#fee-tbody").append(
            `<tr class=${active}>
                <th scope="row">${name}</th>
                <td class="word-break">${fee[name]}</td>
            </tr>`
        );
      }
    });

    return (
      <div>
        <div class="row">
            <div class="col-lg-12 col-md-12">
                <div class="card-box">
                    <h4 class="header-title m-t-0 m-b-30">{data.whatisDao}</h4>

                    <div class="widget-box-2">
                        <div class="widget-detail-2">
                            <h4 class="text-left"> {data.explainDao}</h4>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="row">
            <div class="col-lg-12 col-md-12">
                <div class="card-box">
                    <h4 class="header-title m-t-0 m-b-30">{data.ethforWithdraw} </h4>

                    <div class="widget-box-2">
                        <div class="widget-detail-2">
                            <h4 class="text-left"> {data.explainGas}</h4>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="row">
            <div class="col-lg-12 col-md-12">
                <div class="card-box">
                    <h4 class="header-title m-t-0 m-b-30">Q. {data.aidaopolicy} </h4>

                    <div class="widget-box-2">
                        <div class="widget-detail-2">
                            <h4 class="text-left">
                                {data.aidaosendinginfo}
                            </h4>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="row">
            <div class="col-lg-12 col-md-12">
                <div class="card-box">
                    <h4 class="header-title m-t-0 m-b-30">{data.airdropWithdraw}</h4>

                    <div class="widget-box-2">
                        <div class="widget-detail-2">
                            <h4 class="text-left"> {data.deductDao}</h4>

                            <div class='table-responsive'>
                            <table class="table m-b-0" id="history-table">
                                <thead>
                                    <tr>
                                        <th>{data.tokenName}</th>
                                        <th>{data.deductionRate}</th>
                                    </tr>
                                </thead>
                                <tbody id="history-tbody">

                                </tbody>
                            </table>
                            </div>

                            <div class="m-t-20"></div>

                            <h4 class="text-left"> {data.noticeManualApproval}
                            </h4>

                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="row">
            <div class="col-lg-12 col-md-12">
                <div class="card-box">
                    <h4 class="header-title m-t-0 m-b-30">Fee Rate</h4>

                    <div class="widget-box-2">
                        <div class="widget-detail-2">
                            <h4 class="text-left">We deduct some amount of the token to reimburse the high gas fee sending token to you</h4>

                            <div class='table-responsive'>
                            <table class="table m-b-0" id="history-table">
                                <thead>
                                    <tr>
                                        <th >{data.tokenName}</th>
                                        <th>Amount</th>
                                    </tr>
                                </thead>
                                <tbody id="fee-tbody">
                                </tbody>
                            </table>
                            </div>

                            <div class="m-t-20"></div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="row">
            <div class="col-lg-12 col-md-12">
                <div class="card-box" id="swapcenterinfo">
                    <h4 class="header-title m-t-0 m-b-30">Q. What is Swap Center </h4>

                    <div class="widget-box-2">
                        <div class="widget-detail-2">
                            <h4 class="text-left"> Swap center integrated with decentralized exchange to
                            provide liquidity to convert your airdropped tokens. Note that we have minimum
                            of 0.055 ether equivalent token conversion. Beside the fee charged by decentralized
                            exchange, we also charge 0.2% of the fee. We are in beta period and currently only offer
                            conversion to ether. Note that in current beta version, there is a maximum of token you can convert
                            each time. It depends on the market, but in general if you convert less than 0.15 ether equivalent
                            of token, it should not impact your conversion. When you convert token to ether, the converted ether will be
                            sent to your DAO wallet ether address.
                            </h4>

                            <h4 class="text-left"> The token to token beta-version swaping is also available.
                            </h4>
                            <h4 class="text-left"> Radar Relay and ERCDEX Integration allow swaping your ETH to anther tokens
                            In that case, you will need to provide some eth as gas.
                            </h4>

                            <h4 class="text-left"> Radar Relay and ERCDEX beta-version both offer ETH/DAI swapping, you can click on the icon to switch which DEX
                            you want to swap in. Mininum swap from ERCDEX is 0.05 ether
                            </h4>

                            <h4 class="text-left"> Morph Integration beta-version both offer ETH/BTC swapping. Mininum swap from ERCDEX is 0.15 ether
                            </h4>

                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="row">
            <div class="col-lg-12 col-md-12">
                <div class="card-box">
                    <h4 class="header-title m-t-0 m-b-30">Q. How to Contact us </h4>

                    <div class="widget-box-2">
                        <div class="widget-detail-2">
                            <h4 class="text-left"> Email daotokenwallet@gmail.com
                            </h4>
                        </div>
                    </div>
                </div>
            </div>
        </div>




    </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/dashboard/notification.js